<template>
    <section class="section">
        <div class="container">
            <h1 class="title is-4">E-conomic</h1>

            <div class="columns">
                <div class="column">
                    <setting
                        label="Aktiver E-conomic integration"
                        skey="integration.economic.enabled"
                        :is-boolean="true"
                        :has-icon="false"
                    />

                    <div class="field" v-if="economicIsEnabled">
                        <p>
                            Før integrationen kan fungere skal NORDICorder have
                            adgang til din E-conomic aftale.<br />
                            Klik på knappen neden for og følg anvisningerne,
                            returner her med det Grant ID der bliver
                            præsenteret.
                        </p>

                        <p>
                            <a
                                :href="economicRegisterUrl"
                                target="_blank"
                                class="button is-primary"
                                >Registrer NORDICorder i din E-conomic aftale</a
                            >
                        </p>

                        <setting
                            label="E-conomic Grant ID"
                            skey="integration.economic.grant"
                            :has-icon="false"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { FormField, InputText, InputCheckbox } from "@elems/form";
import store from "../../../store";
import Setting from "./../Setting.vue";

export default {
    components: {
        FormField,
        InputText,
        InputCheckbox,
        Setting,
    },
    data() {
        return {
            form: {
                economic: {
                    active: 0,
                    grant: "",
                },
            },
        };
    },

    computed: {
        economicIsEnabled() {
            const setting =
                this.$store.getters.settingByKey(
                    "integration.economic.enabled"
                ) || {};
            return setting.value === 1;
        },
        economicRegisterUrl() {
            return (
                "https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appPublicToken=" +
                window.app.economicPublicKey
            );
        },
    },
    created() {
        store.dispatch("loadSettings");
    },
};
</script>
